import { useMutation } from '@tanstack/react-query';
import channelsUtil from '../../../helpers/channelsUtil';
import useBraze from '../../../hooks/useBraze';
import { BRAZE } from '../../../config/analytics-events';
import users from '../../../actions/users';
import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '@intigral/domain/lib/DataDomain';
import { IAuthService } from '@intigral/domain/lib/application/services/AuthService';
import { getUserInfo } from '../../../utils/user';
import { isGuestUser } from '../../../config/guestMode';
import { useContext } from 'react';
import { MixpanelContext } from '../../../contexts/MixpanelContext';
import type { MixpanelContextType } from '../../../contexts/MixpanelContext';
import { EVENT, KEYS } from '../../../contexts/MixpanelConstants';

export const useLogout = () => {
    const { logBrazeCustomEvent, flushBrazeData } = useBraze();
    const { track, setUserProperties, reset }: any = useContext(MixpanelContext) as MixpanelContextType;

    const { mutate: logoutUser } = useMutation({
        mutationFn: async () => {
            const currentUser = getUserInfo();
            if (!currentUser?.username || isGuestUser(currentUser)) {
                return null;
            }
            return await container
                .resolve<IAuthService>(DI.SERVICES.IAuthService)
                .logout(currentUser.username, currentUser.authToken, currentUser.identityToken, currentUser.authSign);
        },
        onSuccess: async () => {
            await logoutHandler();
        },
        onError: async (_error: any) => {
            await logoutHandler();
        },
    });

    const logoutHandler = async () => {
        setUserProperties({
            [KEYS.PEOPLE.LAST_SIGN_OUT]: channelsUtil.getCurrentDateTime(),
        });
        track(EVENT.LOGIN.SIGN_OUT);
        logBrazeCustomEvent(BRAZE.EVENTS.APP_SIGNOUT);
        reset();
        users.logoutUser();
        await flushBrazeData();
    };

    return {
        logoutUser,
    };
};
